import "whatwg-fetch";

function getApiPath(path) {
  return `https://vkn2tuu7zd.execute-api.us-east-1.amazonaws.com/dev${path}`;
}

export function fetchFiles(token) {
  return fetch(getApiPath("/api/files"), {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then(response => response.json());
}

export function fetchToken(slug, password) {
  return fetch(getApiPath("/api/token"), {
    method: "POST",
    body: JSON.stringify({
      slug,
      password
    })
  }).then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/Util/PrivateFiles.js